import { Alert, Flex } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

type Props = { changeCount: number; deleteCount: number };

export const PendingEditsBanner = ({ changeCount, deleteCount }: Props) => {
  if (changeCount < 1 && deleteCount < 1) return null;

  const lines: string[] = [];
  if (changeCount > 0) {
    lines.push(
      changeCount === 1
        ? appstr("1 box style with unsaved changes")
        : appstr("{n} box styles with unsaved changes", { n: changeCount })
    );
  }
  if (deleteCount > 0) {
    lines.push(
      deleteCount === 1
        ? appstr("1 box style deleted")
        : appstr("{n} box styles deleted", { n: deleteCount })
    );
  }

  return (
    <Flex padding="0 16px 16px">
      <Alert severity="info">
        {lines.length === 1 ? (
          lines[0]
        ) : (
          <ul className="ocn-box-styles-pending-list">
            {lines.map(line => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        )}
      </Alert>
    </Flex>
  );
};
